/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Equal_Fine_Termite_HugInputs */

const fr_equal_fine_termite_hug = /** @type {(inputs: Equal_Fine_Termite_HugInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sur liste d'attente`)
};

/**

* @param {Equal_Fine_Termite_HugInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const equal_fine_termite_hug = /** @type {((inputs?: Equal_Fine_Termite_HugInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Equal_Fine_Termite_HugInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_equal_fine_termite_hug(inputs)
});